import { Partner } from 'types';
import { sindicationTypes } from 'modules/partners/constants/sindicationTypes';

export const isFullSindicated = (partner: Partner): boolean =>
  !!partner?.sindication && partner?.sindicationType === sindicationTypes.FULL;
